const initMobileSearch = function() {
  document.querySelector('#mobile-search-btn').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.header-mobile__search-row').classList.toggle('active');
  });
};

export default initMobileSearch;
